/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SubmitIdentityProviderConnectionClientIDRequestBody,
  SubmitIdentityProviderConnectionClientIDRequestBody$Outbound,
  SubmitIdentityProviderConnectionClientIDRequestBody$outboundSchema,
} from "../components/submitidentityproviderconnectionclientidrequestbody.js";

export type SubmitIdentityProviderConnectionClientIdSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type SubmitIdentityProviderConnectionClientIdRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  submitIdentityProviderConnectionClientIDRequestBody:
    SubmitIdentityProviderConnectionClientIDRequestBody;
};

/** @internal */
export type SubmitIdentityProviderConnectionClientIdSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const SubmitIdentityProviderConnectionClientIdSecurity$outboundSchema:
  z.ZodMiniType<
    SubmitIdentityProviderConnectionClientIdSecurity$Outbound,
    SubmitIdentityProviderConnectionClientIdSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function submitIdentityProviderConnectionClientIdSecurityToJSON(
  submitIdentityProviderConnectionClientIdSecurity:
    SubmitIdentityProviderConnectionClientIdSecurity,
): string {
  return JSON.stringify(
    SubmitIdentityProviderConnectionClientIdSecurity$outboundSchema.parse(
      submitIdentityProviderConnectionClientIdSecurity,
    ),
  );
}

/** @internal */
export type SubmitIdentityProviderConnectionClientIdRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  SubmitIdentityProviderConnectionClientIDRequestBody:
    SubmitIdentityProviderConnectionClientIDRequestBody$Outbound;
};

/** @internal */
export const SubmitIdentityProviderConnectionClientIdRequest$outboundSchema:
  z.ZodMiniType<
    SubmitIdentityProviderConnectionClientIdRequest$Outbound,
    SubmitIdentityProviderConnectionClientIdRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      submitIdentityProviderConnectionClientIDRequestBody:
        SubmitIdentityProviderConnectionClientIDRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        submitIdentityProviderConnectionClientIDRequestBody:
          "SubmitIdentityProviderConnectionClientIDRequestBody",
      });
    }),
  );

export function submitIdentityProviderConnectionClientIdRequestToJSON(
  submitIdentityProviderConnectionClientIdRequest:
    SubmitIdentityProviderConnectionClientIdRequest,
): string {
  return JSON.stringify(
    SubmitIdentityProviderConnectionClientIdRequest$outboundSchema.parse(
      submitIdentityProviderConnectionClientIdRequest,
    ),
  );
}
